import React, { memo } from 'react';
import SimpleReactSelect from '../formElements/SimpleReactSelect/indexRevamp';
import countryCodes from '@constants/countryCodes.json';
import cn from 'classnames';
import Styles from './index.module.scss';
import { getObjectValue } from "@utility/utills";
import { safeJsonParse } from '@utility/helperFunction';

const PhoneNumberComponent = (props) => {
  // Props Destructuring
  const {
    countryCode,
    styles,
    handleCountryCodeChange,
    maxMenuHeight,
    isHeight,
    onSelect = () => {
      true;
    },
    isCustomWidth = "col-2",
    ShowLandscapeMode,
    QRLink,
    swipedDown,
    isLandScape,
    isDisabled,
    screenType,
    serverAppTheme,
    editCallCenter,
    isCallCenter,
    isTogo,
    orderingPortraitOrientation
  } = props;

  // Methods

  const deviceInfo = safeJsonParse(window.sessionStorage.getItem("deviceInfo"), {});

  const isDriveThru = getObjectValue(
    () => [3].includes(deviceInfo.deviceGroup?.startMode),
    false
  );

  const isCounter = getObjectValue(
    () => [1].includes(deviceInfo.deviceGroup?.startMode),
    false
  );

  const options = countryCodes.map((code) => {
    return {
      name: screenType === 'SendQRLink' ? `(+${code?.dialCode})` : `${code?.code} (+${code?.dialCode})`,
      id: code?.dialCode,
      code: code?.code,
    };
  });

  const sortedOptions = options.sort((a, b) => {
    if (a?.code?.toLowerCase() < b?.code?.toLowerCase()) return -1;
    if (a?.code?.toLowerCase() > b?.code?.toLowerCase()) return 1;
    return 0;
  });
  let code = countryCode?.toString() || '1'
  const isGuestInfoPage = window.location.pathname === '/callcenter/guestinformation';

  const shouldApplyZIndex =
    !QRLink && !isTogo && !isCallCenter;
  // HTML CSS CODE
  return (
    <div
      className={cn(
        'position-absolute fw-500',
        isCallCenter && !isGuestInfoPage && 'h-5',
        (isCallCenter && isGuestInfoPage) ? orderingPortraitOrientation ? 'px-0': 'pr-0 pl-3' : 'px-0',
        isTogo && 'h-5',
        screenType != "callCenterLogin" && screenType !== "orderMenuTop" ? "h-100" : "",
        isCustomWidth,
        shouldApplyZIndex && Styles.countryCodeZIndex,
        Styles.dropDown,
        (isCounter || isDriveThru) ? "h-100" : ""
      )}
      style={{
        ...styles,
        "--svg-color": serverAppTheme ? serverAppTheme?.primary_text : "white",
      }}
    >
      <SimpleReactSelect
        options={sortedOptions}
        isHeight={isHeight}
        onSelect={onSelect}
        onChange={handleCountryCodeChange}
        maxMenuHeight={maxMenuHeight}
        defaultValue={code}
        className="fs-12 h-100 w-100"
        customStyles={cn(Styles.select)}
        ShowLandscapeMode={ShowLandscapeMode}
        QRLink={QRLink}
        swipedDown={swipedDown}
        isLandScape={isLandScape}
        isDisabled={isDisabled}
        screenType={screenType}
        isCounter={isCounter}
        serverAppTheme={serverAppTheme}
        name="phoneNumOffPremise"
        editCallCenter={editCallCenter}
        isDriveThru={isDriveThru}
        isTogo={isTogo}
      />
    </div>
  );
};

export default memo(PhoneNumberComponent);
